export function getFullName(tabs) {
    return tabs.map(tab => tab.value).join('_');
}

export function getVariableValue(tabName) {
    return `%${tabName.toLowerCase()}%`;
}